import { useCallback } from 'react';

import { redirectActions } from '../../../entities/history';
import { useWindowWidth } from '@distribute/frontend/utils';
import { useDispatch } from 'react-redux';

import { pagesModel } from '../../../features/pages';

export const useOpenEditor = (sequenceNumber: string) => {
  const { isMobile } = useWindowWidth();
  const dispatch = useDispatch();

  const handlePageEditorClick = useCallback(() => {
    if (isMobile) {
      dispatch(redirectActions.toEditorPage({ sequenceNumber }));
      dispatch(pagesModel.actions.setIsEditorPreview(true));
    } else {
      dispatch(redirectActions.toEditorPage({ sequenceNumber }));
    }
  }, [dispatch, sequenceNumber, isMobile]);

  return { handlePageEditorClick };
};
